import { config } from '@abyss/web/tools/config';

import { useCustomQuery } from '../useCustomQuery';
import POST_PROVIDER_INFO_QUERY from './PostProviderInfo.graphql';

export const usePostProviderInfo = (options) =>
  useCustomQuery(POST_PROVIDER_INFO_QUERY, {
    ...options,
    url: config('GRAPHQL_API_URL'),
    accessor: 'postProviderInfo',
  });
